import { render, staticRenderFns } from "./OverviewMenu.vue?vue&type=template&id=771c5bfc&scoped=true"
import script from "./OverviewMenu.vue?vue&type=script&lang=js"
export * from "./OverviewMenu.vue?vue&type=script&lang=js"
import style0 from "./OverviewMenu.vue?vue&type=style&index=0&id=771c5bfc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771c5bfc",
  null
  
)

export default component.exports